import React, { useState, useEffect } from 'react';
import { Button, Dropdown } from '@themesberg/react-bootstrap';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { getCustomer } from '../../redux/actions/customer';
import { tableTheme, tableThemeStatic } from '../../helpers/tableTheme';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisH,
  faEdit,
  faTable,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import TableLinkComponent from '../../components/TableLinkComponent';

function ViewCustomer({ history }) {
  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/customers/profile/${rowData[0]}`);
  };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    responsive: 'standard',
    print: false,
    download: false,
    // onRowClick: onRowsSelect,
    elevation: 0,
  };

  const columns = [
    {
      name: 'Customer Id',
      label: 'Customer Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'Name',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => (
          <TableLinkComponent
            value={value}
            onClick={() =>
              history.push(`/customers/profile/${tableMeta.rowData[0]}`)
            }
          />
        ),
      },
    },
    'Location',
    {
      name: 'Phone Number',
      label: 'Phone Number',
      options: {
        filter: false,
        sort: false,
      },
    },
    'Business Type',
    {
      name: 'Collector Id',
      label: 'Collector Id',
      options: {
        filter: false,
        sort: false,
        display: 'excluded',
      },
    },
    {
      name: 'Assigned Collector',
      label: 'Assigned Collector',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => (
          <TableLinkComponent
            value={value}
            onClick={() =>
              history.push(`/collectors/profile/${tableMeta.rowData[5]}`)
            }
          />
        ),
      },
    },

    {
      name: 'Collector Number',
      label: 'Collector Number',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'Action',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <Dropdown onClick={(e) => e.stopPropagation()}>
            <Dropdown.Toggle
              as={Button}
              variant='light'
              size='sm'
              // className='customToggleDropdown'
              // className="me-2"
            >
              <FontAwesomeIcon
                icon={faEllipsisH}
                style={{
                  color: '#262B40',
                  fontSize: 10,
                }}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
              <Dropdown.Item
                style={{ fontSize: 14 }}
                onClick={() => history.push(`/customers/profile/${value}`)}
              >
                <FontAwesomeIcon icon={faEye} className='me-2' /> View Customer
              </Dropdown.Item>
              <Dropdown.Item
                style={{ fontSize: 14 }}
                onClick={() => history.push(`/customers/edit/${value}`)}
              >
                <FontAwesomeIcon icon={faEdit} className='me-2' /> Edit Customer
              </Dropdown.Item>
              {/* <Dropdown.Divider /> */}

              <Dropdown.Item
                style={{ fontSize: 14 }}
                onClick={() =>
                  history.push(`/customers/transaction/detail/${value}`)
                }
              >
                <FontAwesomeIcon icon={faTable} className='me-2' /> View
                Transactions
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
    },
  ];

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const customerData = useSelector((state) => state.customer.customerData);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getCustomer()).then(() => setIsLoading(false));
  }, []);

  return (
    <div>
      <MuiThemeProvider theme={tableThemeStatic}>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <MUIDataTable
            title={'View Customer'}
            data={customerData}
            columns={columns}
            options={options}
          />
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default ViewCustomer;
